import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Components 

import Box from '@mui/material/Box';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

interface Props { 
    extraStyle?: any; 
    handler: any; 
}; 

const CancelButton: React.FC<Props> = ({ extraStyle, handler }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const colors = useAppSelector(state => state.theme.colors); 

    return (

        <CancelOutlinedIcon 
            onClick={handler}
            sx={[{ 
                fontSize: 30, 
                color: colors?.cancelButtonText, 
                cursor: 'pointer', 
                position: 'absolute',
                top: 15,
                right: 15, 
                '&:hover': { color: colors?.red },
            }, extraStyle]} 
        />

  );

};

export default CancelButton;